import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import * as QuillNamespace from 'quill';

@Component({
  selector: 'app-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.css'],
})
export class RichTextEditorComponent implements OnInit {
  @ViewChild('editor') editor: QuillEditorComponent;
  Quill: any = QuillNamespace;
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],

      ['clean'],
      ['link', 'image', 'video'],
    ],
  };
  @Input() richText: any;
  @Input() isDisable: any;
  @Input() ngClassCon: any;
  @Input() isRequired: any;
  @Input() maxTextLength: any;
  @Output() richTooLong = new EventEmitter<any>();
  @Output() saveText = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  @Output() focus = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    var DirectionAttribute = this.Quill.import('attributors/attribute/direction');
    this.Quill.register(DirectionAttribute, true);

    var AlignClass = this.Quill.import('attributors/class/align');
    this.Quill.register(AlignClass, true);

    var BackgroundClass = this.Quill.import('attributors/class/background');
    this.Quill.register(BackgroundClass, true);

    var ColorClass = this.Quill.import('attributors/class/color');
    this.Quill.register(ColorClass, true);

    var DirectionClass = this.Quill.import('attributors/class/direction');
    this.Quill.register(DirectionClass, true);

    var FontClass = this.Quill.import('attributors/class/font');
    this.Quill.register(FontClass, true);

    var SizeClass = this.Quill.import('attributors/class/size');
    this.Quill.register(SizeClass, true);

    var AlignStyle = this.Quill.import('attributors/style/align');
    this.Quill.register(AlignStyle, true);

    var BackgroundStyle = this.Quill.import('attributors/style/background');
    this.Quill.register(BackgroundStyle, true);

    var ColorStyle = this.Quill.import('attributors/style/color');
    this.Quill.register(ColorStyle, true);

    var DirectionStyle = this.Quill.import('attributors/style/direction');
    this.Quill.register(DirectionStyle, true);

    var FontStyle = this.Quill.import('attributors/style/font');
    this.Quill.register(FontStyle, true);

    var SizeStyle = this.Quill.import('attributors/style/size');
    this.Quill.register(SizeStyle, true);
  }

  public checkRichLength() {
    //this.richTooLong.emit(false);
    if (this.richText != null) {
      if (this.richText.length > this.maxTextLength) this.richTooLong.emit(true);
      else this.richTooLong.emit(false);
    }
    this.saveText.emit(this.richText);
    this.onChange.emit(true);
  }

  public focusEditor() {
    this.focus.emit(true);
  }
}
